import { Reveal, SectionHeading } from "./Reveal";

const row1 = ["Apple", "Samsung", "HP", "Dell", "Lenovo", "ASUS", "Acer", "Logitech", "Microsoft", "UGREEN", "TP-Link", "Hikvision"];
const row2 = ["DJI", "Huawei", "Bose", "Garmin", "Makita", "CyberPower", "EcoFlow", "EZVIZ", "Jabra", "Victorinox", "Epcom", "y muchas más"];

const BrandRow = ({ brands, reverse }) => (
  <div className="marquee-paused overflow-hidden">
    <div className={reverse ? "marquee-track-reverse" : "marquee-track-slow"}>
      {[0, 1].map((n) => (
        <div key={n} className="flex items-center shrink-0">
          {brands.map((b) => (
            <span
              key={b + n}
              className="brand-word font-display text-3xl md:text-5xl font-semibold tracking-tight px-8 md:px-12 whitespace-nowrap flex items-center gap-8 md:gap-12"
            >
              {b}
              <span className="h-2 w-2 rounded-full bg-ecamber/60 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default function Brands() {
  return (
    <section id="marcas" className="relative py-24 md:py-36 bg-white overflow-hidden" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="05"
          chapter="Marcas"
          id="marcas"
          title={<>Las marcas que su negocio <span className="text-ecamber">reconoce</span></>}
          sub="Trabajamos con los fabricantes líderes de la industria tecnológica global."
        />
      </div>
      <Reveal className="mt-16 space-y-8">
        <BrandRow brands={row1} />
        <BrandRow brands={row2} reverse />
      </Reveal>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-14">
        <Reveal delay={0.1}>
          <p className="text-sm text-slate-500">
            <span className="font-semibold text-ecdeep">Distribuidores autorizados</span> de Samsung, Syscom e Ingram Micro, con acceso directo a inventario y productos con garantía de fábrica.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
